import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ProviderAuthProvider } from "./context/ProviderAuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import AuthPage from "./pages/AuthPage";
import ProceduresPage from "./pages/ProceduresPage";
import ProvidersPage from "./pages/ProvidersPage";
import ProviderDetailPage from "./pages/ProviderDetailPage";
import CostComparisonPage from "./pages/CostComparisonPage";
import TravelPage from "./pages/TravelPage";
import AIAssistantPage from "./pages/AIAssistantPage";
import DashboardPage from "./pages/DashboardPage";
import DisclaimerPage from "./pages/DisclaimerPage";
import ProviderLoginPage from "./pages/provider-portal/ProviderLoginPage";
import ProviderRegisterPage from "./pages/provider-portal/ProviderRegisterPage";
import ProviderSelfRegisterPage from "./pages/provider-portal/ProviderSelfRegisterPage";
import ProviderDashboardPage from "./pages/provider-portal/ProviderDashboardPage";
import AdminClaimRequestsPage from "./pages/AdminClaimRequestsPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import SearchResultsPage from "./pages/SearchResultsPage";
import TotalCostPage from "./pages/TotalCostPage";
import MyAlertsPage from "./pages/MyAlertsPage";
import DPCLandingPage from "./pages/DPCLandingPage";
import DPCRegisterPage from "./pages/DPCRegisterPage";
import DPCLoginPage from "./pages/DPCLoginPage";
import DPCDashboardPage from "./pages/DPCDashboardPage";

function AppLayout({ children, hideFooter }) {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-1">{children}</main>
      {!hideFooter && <Footer />}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <ProviderAuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Patient auth — no navbar */}
            <Route path="/auth" element={<AuthPage />} />

            {/* DPC Physician Portal — standalone layout (no main navbar) */}
            <Route path="/dpc/register" element={<DPCRegisterPage />} />
            <Route path="/dpc/login" element={<DPCLoginPage />} />
            <Route path="/dpc/dashboard" element={<DPCDashboardPage />} />

            {/* Provider portal — standalone layout */}
            <Route path="/provider-portal/login" element={<ProviderLoginPage />} />
            <Route path="/provider-portal/register" element={<ProviderRegisterPage />} />
            <Route path="/provider-portal/dashboard" element={<ProviderDashboardPage />} />
            <Route path="/provider/register" element={<ProviderSelfRegisterPage />} />
            <Route path="/admin/claim-requests" element={<AdminClaimRequestsPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
            <Route path="/search-results" element={<SearchResultsPage />} />

            {/* AI Assistant — no footer */}
            <Route path="/ai-assistant" element={
              <AppLayout hideFooter>
                <AIAssistantPage />
              </AppLayout>
            } />

            {/* Main app — with navbar + footer */}
            <Route path="/*" element={
              <AppLayout>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/procedures" element={<ProceduresPage />} />
                  <Route path="/price-search" element={<ProceduresPage />} />
                  <Route path="/providers" element={<ProvidersPage />} />
                  <Route path="/provider/:id" element={<ProviderDetailPage />} />
                  <Route path="/compare" element={<CostComparisonPage />} />
                  <Route path="/travel" element={<TravelPage />} />
                  <Route path="/total-cost" element={<TotalCostPage />} />
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/disclaimer" element={<DisclaimerPage />} />
                  <Route path="/my-alerts" element={<MyAlertsPage />} />
                  <Route path="/for-physicians" element={<DPCLandingPage />} />
                </Routes>
              </AppLayout>
            } />
          </Routes>
        </BrowserRouter>
      </ProviderAuthProvider>
    </AuthProvider>
  );
}

export default App;
